import { Injectable } from '@angular/core';

@Injectable()
export class SessionStorageProvider {

  constructor() {}

  getItem(name: any): string | null {
    return window.sessionStorage.getItem(name);
  }

  getItemAsJSON(name: any): any {
    return JSON.parse(this.getItem(name));
  }

  setItem(name: any, item: any): void {
    window.sessionStorage.setItem(name, item);
  }

  setItemFromJSON(name: any, item: any): void {
    window.sessionStorage.setItem(name, JSON.stringify(item));
  }

  removeItem(name: any): void {
    window.sessionStorage.removeItem(name);
  }

}
